import { useQuery } from "@tanstack/react-query";
import { bankInfoQueryApi } from "@/shared/api/bank-info/query";
import { BuyerBankInfoResponse } from "@/shared/api/bank-info/types";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

// 바이어 기본 환불 계좌 조회 훅 — 바이어 페이지에서는 companyId가 buyer_id다.
// 미등록이면 null이 오는 것이 정상이라 에러로 다루지 않는다.
// 비suspense 쿼리로 두어 호출하는 카드가 자체 로딩만 처리하고 페이지는 멈추지 않게 한다.
const useGetBuyerBankInfo = () => {
  const { companyId } = useCompanyIdentity();

  const { data: buyerBankInfo, isPending } = useQuery({
    queryKey: ["buyer-bank-info", companyId],
    queryFn: () => bankInfoQueryApi.getBuyerBankInfo(companyId as number),
    // toCamelKeyObject는 null을 그대로 돌려주므로 미등록 응답도 안전하다.
    select: (data) => toCamelKeyObject(data) as BuyerBankInfoResponse | null,
    enabled: Boolean(companyId),
  });

  return { buyerBankInfo, isPending };
};

export default useGetBuyerBankInfo;
